<script>
    import {mapGetters, mapActions} from 'vuex'
    import { Bar } from 'vue-chartjs'
    import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

    ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

    export default {
        extends: Bar,

        props: ['chartData'],

/*
        watch: {
            chartData() {
                this.renderChart(this.chartData, this.chartOptions)
            }
        },
*/

        data() {
            let self = this

            return {
              chartData: {
                    scales: {
                        xAxes: [{
                          display: true,
                          stacked: true,
                          position: 'top',
                          ticks: {
                              beginAtZero: true
                          }
                        }],
                        yAxes: [{
                            display: true,
                            stacked: true
                        }]
                    },
                    // maintainAspectRatio: true,
                    responsive: true,
                    legend: {
                        position: 'right',
                    },
                    title: {
                        display: false,
                        text: 'Chart.js Horizontal Bar Chart'
                    },

                    onClick(e, datasets) {
                        if (datasets.length) {
                            self.$emit('chartclick', datasets[0]._index)
                        }
                    }
                }
            }
        }
    }
</script>

<style>
    canvas {
        width: 100% !important;
    }
</style>
